import { useQuery } from '@tanstack/react-query'

import { recruiterDashboardApi } from '@/features/recruiter/api/dashboard.api'

export function useRecruiterDashboardQuery() {
  return useQuery({ queryKey: ['recruiter', 'dashboard'], queryFn: recruiterDashboardApi.get })
}
